import {
  getMedicationStatusFlags,
  isMedicationOutOfService
} from '@/components/PatientPageV2/components/PrescriptionPad';
import { reissueStatusStore } from '../constants';
import type { PrescriptionAssistantSliceType } from '../types';

export const isValidPrescriptionPad = (get: () => PrescriptionAssistantSliceType) => {
  const state = get();
  const itemsToCancel = state?.prescriptionAssistant?.prescriptionHistory?.itemsToCancel || [];
  const medicationPadItems = state?.prescriptionAssistant?.prescriptionPad?.medicationPadItems || [];
  const isMedicationPadItemFilterInprogress = medicationPadItems.some((item) => !!item.filters);

  // check if there are items to cancel & no other medications in the pad
  // check if there are any empty medications (without filters)
  if (Boolean(itemsToCancel.length) && !isMedicationPadItemFilterInprogress) {
    return true;
  }

  const hasMedicationsWithErrorMessage = get()?.prescriptionAssistant?.prescriptionPad?.medicationPadItems?.some(
    (item) => !!item?.errorMessage
  );

  const hasOutOfServiceMedication = medicationPadItems.some(({ reissueStatus, medicationPadItem }) => {
    reissueStatusStore.current = reissueStatus
      ? {
          productId: reissueStatus.productId,
          ...getMedicationStatusFlags(reissueStatus)
        }
      : null;

    const isOutOfService = reissueStatus && isMedicationOutOfService(reissueStatus);

    return reissueStatusStore.current?.productId === medicationPadItem?.productId && isOutOfService;
  });

  return (
    // check if there are medications in the precription pad
    Boolean(get()?.prescriptionAssistant?.prescriptionPad?.medicationPadItems.length) &&
    // check if all the medications in the prescription pad have selected product
    Boolean(
      get()?.prescriptionAssistant?.prescriptionPad?.medicationPadItems?.every((item) => !!item.medicationPadItem)
    ) &&
    // Check that no medications in the prescription pad have an error message
    Boolean(!hasMedicationsWithErrorMessage) &&
    // Check that no reissued medications are out of service
    Boolean(!hasOutOfServiceMedication)
  );
};
